export const WAITING_ROOM_NOTIFICATION_SUFFIX = 'has joined their consultation and is now in the Waiting Room';
